var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C5.2802 2.25 2.25 5.2802 2.25 9C2.25 12.7198 5.2802 15.75 9 15.75C12.7198 15.75 15.75 12.7198 15.75 9C15.75 5.2802 12.7198 2.25 9 2.25ZM9 3.28846C12.16 3.28846 14.7115 5.83999 14.7115 9C14.7115 12.16 12.16 14.7115 9 14.7115C5.83999 14.7115 3.28846 12.16 3.28846 9C3.28846 5.83999 5.83999 3.28846 9 3.28846ZM8.98783 5.36538C8.11569 5.36538 7.43014 6.11583 7.43014 6.99204V7.44231H6.92308C6.63507 7.44231 6.40385 7.67353 6.40385 7.96154V11.0769C6.40385 11.3649 6.63507 11.5962 6.92308 11.5962H11.0769C11.3649 11.5962 11.5962 11.3649 11.5962 11.0769V7.96154C11.5962 7.67353 11.3649 7.44231 11.0769 7.44231H10.5455V6.99204C10.5455 6.11583 9.85998 5.36538 8.98783 5.36538ZM8.98783 6.40385C9.25556 6.40385 9.50706 6.64724 9.50706 6.99204V7.44231H8.4686V6.99204C8.4686 6.64724 8.7201 6.40385 8.98783 6.40385ZM7.44231 8.48077H10.5577V10.5577H7.44231V8.48077Z",
    fill: "#2C55A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.77a1dfc91deb927cca86a6a5760b386f.svg";
export { ForwardRef as ReactComponent };